import { Navigate } from "react-router-dom";

// Private Route for Admin Dashboard
const PrivateRoute = ({ children }) => {
  const isAdminLoggedIn = sessionStorage.getItem("isAdminLoggedIn");

  // If not logged in, redirect to login page
  if (!isAdminLoggedIn) {
    return <Navigate to="/admin-login" />;
  }

  return children;
};


export default PrivateRoute;